import { Component, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
// import { BaseComponent } from '../../../modules/tcm-core.module';
import { Subscription } from 'rxjs/internal/Subscription';
import { permissionAreaKeyNameOf, permissionEnityKeyNameOf } from '../../../helpers/permission.helpers';
import { BroadCastEvents } from '../../../common/broad-cast-events.enum';
import { AdminArea } from '../../../models/roles';
import { SecureBaseComponentContext } from '../../../modules/tcm-common/services/secure-base-component-context.service';
import { ClinicInfoWidgetRequest } from '../../../models/clinics/clinic-info-widget-request';
import { ClinicInfoWidgetViewModel } from '../../../models/clinics/clinic-info-widget-view-model';
import { UpdateClinicLogoComponent } from './update-logo/update-clinic-logo.component';
import { SystemPreferences, SYSTEM_PREFERENCES } from '../../../common/system-preferences';
import { BaseComponent } from '../../tcm-core.module/components/base-component/base-component.component';

@Component({
    selector: 'clinic-info-widget',
    templateUrl: './clinic-info-widget.component.html',
    styleUrls: ['./clinic-info-widget.component.scss'],
    standalone: false
})
export class ClinicInfoWidgetComponent extends BaseComponent<ClinicInfoWidgetRequest, ClinicInfoWidgetViewModel> {

  private updateSubscription: Subscription;
  private permissionsSubscription: Subscription;
  private refreshSubscription: Subscription;
  public canUpdatePhoto = true;
  public contactPhones: string;

  constructor(
    protected override componentContext: SecureBaseComponentContext, protected override route: ActivatedRoute,
    @Inject(SYSTEM_PREFERENCES) public systemPref: SystemPreferences) {

    super(componentContext, route);

    this.actionName = 'ClinicWidget/InfoWidget';

    this.updateSubscription = this.componentContext.broadcastService
      .getEvents(BroadCastEvents.ClinicLogoChanged, BroadCastEvents.ClinicChanged)
      .subscribe(e => {
        if (e.name == BroadCastEvents.ClinicLogoChanged) {
          this.viewModel.logo = e.args.src;
        }
        else {
          this.refresh();
        }
      });
    
    this.refreshSubscription = this.componentContext.broadcastService.getEvents(BroadCastEvents.ClinicObonoRenewed).subscribe(() => { this.refresh(); });
  
    this.permissionsSubscription = this.componentContext.permissionService
      .getEntityPermissions$(permissionAreaKeyNameOf('admin'), permissionEnityKeyNameOf<AdminArea>('clinics'))
      .subscribe(x => {
        this.canUpdatePhoto = x && x.canEdit === true;
      });
  }

  public openUplaodLogoModal($event) {
    $event.preventDefault();
    $event.stopPropagation();

    this.componentContext.modalService.openComponentInModal(UpdateClinicLogoComponent, "sm", { requestModel: { clinicId: this.requestModel.clinicId } });
  }

  protected override async onViewModelChanged() {
    super.onViewModelChanged();

    this.contactPhones = this.viewModel.contactPhones.join(', ');
  }

  protected createRequestModel(): ClinicInfoWidgetRequest {
    return {} as ClinicInfoWidgetRequest;
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.updateSubscription.unsubscribe();
    this.permissionsSubscription.unsubscribe();
    this.refreshSubscription.unsubscribe();
  }
}
